import { photoshop } from "../../globals";

/**
 * 현재 포토샵에서 크롭 툴이 활성 상태인지 확인한다.
 */
export function isCropToolActive(): boolean {
	try {
		return photoshop.app.currentTool?.id === "cropTool";
	} catch {
		return false;
	}
}
